import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button, DialogActions } from '@material-ui/core';

const TaskAssignmentBulkActionDialogFooter = ({
  onClose,
  onSubmit,
  isBulkActionInProgress,
  confirmButtonTextId,
  confirmButtonColor,
  isLoading
}) => {
  return (
    <DialogActions>
      <Button
        data-qe-id="taskAssignmentBulkActionDialog_Cancel"
        onClick={onClose}
        disabled={isBulkActionInProgress}
        autoFocus
      >
        <FormattedMessage id="taskAssignmentBulkActionDialog.cancel" />
      </Button>
      <Button
        data-qe-id="taskAssignmentBulkActionDialog_Confirm"
        onClick={onSubmit}
        color={confirmButtonColor || 'primary'}
        disabled={isBulkActionInProgress || isLoading}
      >
        <FormattedMessage id={confirmButtonTextId} />
      </Button>
    </DialogActions>
  );
};

TaskAssignmentBulkActionDialogFooter.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isBulkActionInProgress: PropTypes.bool,
  confirmButtonTextId: PropTypes.string.isRequired,
  confirmButtonColor: PropTypes.string,
  isLoading: PropTypes.bool
};

export default TaskAssignmentBulkActionDialogFooter;
